
 import { getCustomerListServices,
  getCustomerDataServices,
  getQuoteListServices,
  getTaskListServices,
  getNotesListServices,
  getActivityListServices,
  getCustomerTaskListServices,
} from '../../../src/services/customerSearchServices';

export const getCustomerListAction = (formData, page = 0, size = 5) => async (dispatch, getState) => {
  try {
      dispatch({ type: 'START_LOADING' }); // Start loading
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await getCustomerListServices(formData, token, page, size);
      dispatch({ type: 'CUSTOMER_SEARCH_LIST_SUCCESS', payload: response });
  } catch (error) {
      dispatch({ type: 'CUSTOMER_SEARCH_LIST_FAILURE', payload: error.message });
  } finally {
      dispatch({ type: 'STOP_LOADING' }); // Stop loading after success or failure
  }
};


export const getCustomerDataAction = (id, page=0, size = 5) => async (dispatch, getState) => {
  try {
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await getCustomerDataServices(token, id, page, size);
      dispatch({ type: 'GET_CUSTOMER_DATA_SUCCESS', payload: response });
  } catch (error) {
      dispatch({ type: 'GET_CUSTOMER_DATA_FAILURE', payload: error.message });
  } finally {
  }
};

export const getQuoteListDataAction = (id, page=0, size = 5) => async (dispatch, getState) => {
  try {
      dispatch({ type: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await getQuoteListServices(token, id, page, size);
      dispatch({ type: 'GET_CUSTOMER_QUOTE_LIST_DATA_SUCCESS', payload: response });
  } catch (error) {
      dispatch({ type: 'GET_CUSTOMER_QUOTE_LIST_DATA_FAILURE', payload: error.message });
  } finally {
      dispatch({ type: 'STOP_LOADING' });
  }
};

export const getTaskListDataAction = (id, page=0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getTaskListServices(token, id, page, size);
        dispatch({ type: 'GET_TASK_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: ' GET_TASK_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };

  export const getNotesListDataAction = (id, page=0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getNotesListServices(token, id, page, size);
        dispatch({ type: 'SEARCH_POLICY_LIST_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'SEARCH_POLICY_LIST_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };

  export const getActivityListDataAction = (id, page=0, size = 5) => async (dispatch, getState) => {
    try {
       
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getActivityListServices(token, id, page, size);
        dispatch({ type: 'GET_ALL_ACTIVITY_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'SET_ALL_ACTIVITY_FAILURE', payload: error.message });
    } finally {
        
    }
  };
